export default "__VITE_ASSET__c2c41515__"